module.exports = __webpack_public_path__ + "72b444b3e08f93f2dc0f58bed86f1aef.jpg";